import React, { ChangeEvent, useMemo } from 'react'
import './ColorSwatchControl.css'

export function normalizeHexColor(hex: string): string {
  const c = (hex || '#ffffff').trim()
  if (/^#[0-9a-f]{6}$/i.test(c)) return c.toLowerCase()
  if (/^#[0-9a-f]{3}$/i.test(c)) {
    const x = c.slice(1)
    return `#${x[0]}${x[0]}${x[1]}${x[1]}${x[2]}${x[2]}`.toLowerCase()
  }
  return '#ffffff'
}

export interface ColorSwatchControlProps {
  value: string
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
  ariaLabel: string
  id?: string
  /** Keeps RTE selection when used inside the template format panel */
  onControlMouseDown?: React.MouseEventHandler<HTMLDivElement>
}

const ColorSwatchControl: React.FC<ColorSwatchControlProps> = ({
  value,
  onChange,
  ariaLabel,
  id,
  onControlMouseDown,
}) => {
  const normalized = useMemo(() => normalizeHexColor(value), [value])
  const displayHex = normalized.toUpperCase()

  return (
    <div className="mt-color-swatch-control" onMouseDown={onControlMouseDown}>
      <input
        id={id}
        type="color"
        className="mt-color-swatch-native"
        value={normalized}
        onChange={onChange}
        aria-label={ariaLabel}
      />
      <div className="mt-color-swatch-row" aria-hidden>
        <div className="mt-color-swatch-left">
          <span
            className="mt-color-swatch-chip"
            style={{ backgroundColor: normalized }}
          />
          <span className="mt-color-swatch-value">{displayHex}</span>
        </div>
        <div className="mt-color-swatch-right">
          <i className="mgc_color_picker_fill" />
        </div>
      </div>
    </div>
  )
}

export default ColorSwatchControl
